module.exports = __webpack_public_path__ + "img/proDP.25afe724.svg";